import { COOKIES_KEY_PREFIX } from '../../constants';
import { datadogRum } from '@datadog/browser-rum';
import { fetchUserWrapper } from './fetch-user';
import { setUserTokenWrapper } from './set-user-token'
import type { AuthObject } from '@white-label-types/auth';
import type { Context } from '@white-label-types/global-context';

/**
 * Checks the SSO session (dedicated flows e.g booking portal) and restores the user state if active.
 * @async
 * @param app - The application context.
 * @param authInstance - The authentication instance.
 * @returns {Promise<void>}
 */
export const checkSSOSessionWrapper = async (
  app: Context['app'],
  authInstance: AuthObject
): Promise<void> => {
  const token = app['$cookies'].get(`${COOKIES_KEY_PREFIX}.${authInstance.clientId}.token`);
  const expiration = app['$cookies'].get(
    `${COOKIES_KEY_PREFIX}.${authInstance.clientId}.tokenExpiration`
  );
  const channelToken = app['$cookies'].get(
    `${COOKIES_KEY_PREFIX}.${authInstance.clientId}.channelToken`
  ) || '';
  if (token) {
    try {
      await fetchUserWrapper(
        token,
        app,
        authInstance
      );

      setUserTokenWrapper(
        token,
        expiration,
        channelToken,
        app,
        authInstance
      );
    } catch (error) {
      datadogRum.addError("sso_session_check", {
        auth: {
          clientId: authInstance.clientId,
          token,
          channelToken,
          expiration,
          isAuthenticated: !!token,
          error
        },
      });
    }
  }
};
